(() => {
  'use strict';
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const data = JSON.parse($('[data-offer-data]', root).textContent);
    const currency = root.dataset.currency || 'USD';
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
    const form = $('[data-offer-form]', root);
    const galleryButtons = $$('[data-gallery-image]', root);
    const mainImage = $('[data-main-image]', root);
    let imageIndex = Math.max(0, galleryButtons.findIndex(button => button.getAttribute('aria-pressed') === 'true'));
    const showImage = index => {
      if (!galleryButtons.length) return;
      imageIndex = (index + galleryButtons.length) % galleryButtons.length;
      const button = galleryButtons[imageIndex];
      mainImage.src = button.dataset.galleryImage;
      mainImage.alt = button.dataset.galleryAlt;
      galleryButtons.forEach((item, i) => item.setAttribute('aria-pressed', String(i === imageIndex)));
    };
    galleryButtons.forEach((button, index) => button.addEventListener('click', () => showImage(index)));
    $('[data-gallery-prev]', root).addEventListener('click', () => showImage(imageIndex - 1));
    $('[data-gallery-next]', root).addEventListener('click', () => showImage(imageIndex + 1));
    $('[data-zoom]', root).addEventListener('click', () => {
      const dialog = document.createElement('dialog');
      dialog.className = 'lightbox';
      const close = document.createElement('button'); close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label', 'Close image');
      const image = document.createElement('img'); image.src = mainImage.src; image.alt = mainImage.alt;
      dialog.append(close, image); document.body.append(dialog); dialog.showModal();
      close.onclick = () => dialog.close();
      dialog.onclick = event => { if (event.target === dialog) dialog.close(); };
      dialog.onclose = () => { dialog.remove(); $('[data-zoom]', root).focus(); };
    });
    if (!form || !data.variants.length) return;
    const native = $('[data-native-variant]', root);
    const selectedVariant = () => data.variants.find(variant => String(variant.id) === native.value) || data.variants[0];
    let stadium = selectedVariant();
    let offer = Number(root.dataset.defaultOffer) || 1;
    const rootUrl = root.dataset.root.replace(/\/?$/, '/');
    const button = $('[data-buy-now]', root);
    const error = $('[data-buy-error]', root);
    let busy = false;
    const showError = message => { error.textContent = message; error.hidden = false; };
    function bundleChoices() {
      if (offer === 1) return [stadium];
      return $$(`[data-bundle-stadium="${offer}"]`, root).map(select => data.variants.find(variant => String(variant.id) === select.value));
    }
    const offerVariant = number => number === 1 ? stadium : data.bundles[String(number)];
    function refresh() {
      $$('[data-offer]', root).forEach(card => {
        const number = Number(card.dataset.offer);
        const variant = offerVariant(number);
        card.classList.toggle('selected', number === offer);
        $('input[name="offer-choice"]', card).checked = number === offer;
        $('input[name="offer-choice"]', card).disabled = !variant?.available || busy;
        const price = $('[data-offer-price]', card);
        price.replaceChildren(document.createTextNode(variant?.available ? money(variant.price) : 'Unavailable'));
        const regular = stadium.price * number;
        if (number > 1 && variant?.available && regular > variant.price) {
          const del = document.createElement('del'); del.textContent = money(regular); price.append(del);
        }
        const badge = $('[data-savings]', card);
        if (badge) {
          const percent = variant && regular ? Math.round((regular - variant.price) * 100 / regular) : 0;
          badge.textContent = `SAVE ${percent}%`; badge.hidden = percent <= 0;
        }
      });
      $('[data-single-price]', root).textContent = money(stadium.price);
      $('[data-stadium-label]', root).textContent = stadium.title;
      const variant = offerVariant(offer);
      const valid = variant?.available && bundleChoices().every(choice => choice?.available);
      button.disabled = busy || !valid;
      button.textContent = busy ? 'Preparing checkout…' : valid ? `BUY NOW · ${money(variant.price)}` : 'Sold out';
    }
    $('[data-enhanced]', root).hidden = false;
    $('.native-variant', root).hidden = true;
    native.disabled = true;
    if (!offerVariant(offer)?.available) offer = 1;
    $$('input[name="stadium-choice"]', root).forEach(radio => radio.addEventListener('change', () => {
      const next = data.variants.find(variant => String(variant.id) === radio.value);
      if (!next) return;
      stadium = next; native.value = String(next.id);
      $$('[data-bundle-stadium]', root).forEach(select => { select.value = String(next.id); });
      const index = galleryButtons.findIndex(item => item.dataset.galleryImage === next.image);
      if (index >= 0) showImage(index);
      refresh();
    }));
    $$('input[name="offer-choice"]', root).forEach(radio => radio.addEventListener('change', () => { offer = Number(radio.value); error.hidden = true; refresh(); }));
    $$('[data-bundle-stadium]', root).forEach(select => select.addEventListener('change', refresh));
    form.addEventListener('submit', async event => {
      event.preventDefault(); if (busy) return;
      const variant = offerVariant(offer), choices = bundleChoices();
      if (!variant?.available || choices.some(choice => !choice?.available) || choices.length !== offer) { showError('Please select an available stadium for each table.'); return; }
      const properties = { 'Tables in this offer': String(offer), 'Included free': 'Priority Shipping, Shipping Protection, 3-Year Warranty, Mystery Gift' };
      choices.forEach((choice, index) => { properties[`Stadium ${index + 1}`] = choice.title; });
      busy = true; error.hidden = true; refresh();
      try {
        const response = await fetch(`${rootUrl}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity: 1, properties }] }) });
        if (!response.ok) {
          const result = await response.json().catch(() => ({}));
          throw new Error(result.description || result.message || 'This offer could not be added. Please check availability and try again.');
        }
        // Shopify owns checkout; no prices or checkout state are fabricated locally.
        window.location.assign(`${rootUrl}checkout`);
      } catch (failure) {
        busy = false; refresh();
        showError(failure instanceof TypeError ? 'Connection interrupted. Check your cart before trying again to avoid adding the offer twice.' : failure.message);
      }
    });
    refresh();
  }
  function initialize(parent = document) {
    $$('[data-stadium-shop]', parent).forEach(setup);
    $$('[data-generic-variant]', parent).forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0], form = select.closest('form');
        const button = $('[type="submit"]', form);
        $('[data-generic-price]', form).textContent = option.dataset.price;
        button.disabled = option.disabled;
        button.textContent = option.disabled ? 'Sold out' : 'Add to cart';
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
